import { useQuery } from "@tanstack/react-query";

import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

import { hubspotEnrichmentQueryKeys } from "./queryKeyFactory";

const useHsEnrichmentJobQuery = (id: string) => {
    return useQuery({
        queryKey: hubspotEnrichmentQueryKeys.job(id),
        queryFn({ signal }) {
            return hubspotEnrichmentAPIService.getJob(id, {
                cancellation: signal,
            });
        },
        enabled: !!id,
        staleTime: 1 * 60 * 1000,
    });
};

export default useHsEnrichmentJobQuery;
